import React from "react";

const progressData = [
  { label: "HTML", percent: 18 },
  { label: "CSS", percent: 10 },
  { label: "Javascript", percent: 35 },
  { label: "Python", percent: 10 },
  { label: "Bootstrap", percent: 45 },
  { label: "React", percent: 45 },
];

const ProgressList = () => {
  return (
    <div className="bg-white p-4 rounded-xl w-full max-w-md inset-shadow-sm">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-sm font-bold text-black mb-0">Derniers progrès</h2>
        <span className="text-sm text-gray-500 font-medium">Plus…</span>
      </div>

      <div className="space-y-4">
        {progressData.map((item, index) => {
          const isValid = item.percent >= 30;

          return (
            <div key={index} className="flex items-center justify-between">
              <span className="w-24 text-sm text-gray-700">{item.label}</span>

              <div className="flex-1 mx-3">
                <div className="w-full h-2 bg-gray-300 rounded-full">
                  <div
                    className={`h-2 rounded-full ${
                      isValid ? "bg-teal-600" : "bg-red-500"
                    }`}
                    style={{ width: `${item.percent}%` }}
                  ></div>
                </div>
              </div>

              <span
                className={`text-sm font-semibold ${
                  isValid ? "text-teal-600" : "text-red-500"
                }`}
              >
                {item.percent}%
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ProgressList;
